import ConfirmModal from "components/ConfirmModal";
import { sidebarMenuStore } from "features/SidebarMenu/SidebarMenuStore";
import { observer } from "mobx-react-lite";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { ROUTES_ENUM } from "routes/consts";
import { buildingStore } from "store/Building/BuildingStore";
import useToast from "hooks/useToast";
import { buildingSettingsStore } from "../BuildingSettings/BuildingSettingsStore";

export default observer(function ArchiveBuilding({
  open,
  close,
}: {
  open: boolean;
  close: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const { t } = useTranslation();
  const { currentBuilding } = buildingStore;
  const navigate = useNavigate();
  const toast = useToast();

  const archiveBuilding = async () => {
    try {
      await buildingSettingsStore.archiveBuilding();
      // Refreshes both the org buildings list and the sidebar (the latter
      // calls getOrganisationBuildings internally) so the now read-only
      // building reflects its archived state.
      await sidebarMenuStore.getCurrentOrgBuildings();
      // Close the building settings modal (it persists via this store flag
      // regardless of whether archive was triggered from the footer or the
      // header dropdown).
      buildingSettingsStore.setOpenEditBuilding(false);
      toast(t("buildingSettings.archiveSuccess"), "success");
      navigate(`/${ROUTES_ENUM.DASHBOARD}`);
    } catch {
      toast(t("buildingSettings.archiveError"), "warning");
    }
  };

  const closeModal = useCallback(() => close(false), [close]);

  return (
    <ConfirmModal
      type="warning"
      open={open}
      close={closeModal}
      containerClassName="min-w-[500px]"
      title={t("buildingSettings.wantToArchive", {
        building_name: currentBuilding?.name,
      })}
      descriptionMesage={t("buildingSettings.archiveWarning")}
      confirmButtonTitle={t("buildingSettings.archiveBuilding")}
      onConfirm={archiveBuilding}
      buttonClassName="bg-red-600 hover:!bg-red-700"
      cancelTitle={t("commons.cancel")}
    ></ConfirmModal>
  );
});
